export default [
  {
    title: 'Escritorio',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Calendario de Actividades',
    route: 'actividades-calendario',
    icon: 'CalendarIcon',
    customClass: 'calendar-menu-item',
  },
  {
    title: 'Plantillas de Correo',
    route: 'plantillas-lista',
    icon: 'MailIcon',
  },
  {
    title: 'Proyectos',
    icon: 'FolderIcon',
    children: [
      {
        title: 'Lista de Proyectos',
        route: 'proyectos-lista',
        icon: 'ListIcon',
      },
      {
        title: 'Nuevo Proyecto',
        route: 'proyectos-nuevo',
        icon: 'PlusIcon',
      },
    ],
  },
  {
    title: 'Actividades',
    icon: 'CheckSquareIcon',
    children: [
      {
        title: 'Lista de Actividades',
        route: 'actividades-lista',
        icon: 'ListIcon',
      },
      {
        title: 'Nueva Actividad',
        route: 'actividades-nueva',
        icon: 'PlusIcon',
      },
    ],
  },
  {
    title: 'Obras',
    icon: 'ToolIcon',
    children: [
      {
        title: 'Lista de Obras',
        route: 'obras-lista',
        icon: 'ListIcon',
      },
      {
        title: 'Nueva Obra',
        route: 'obras-nueva',
        icon: 'PlusIcon',
      },
    ],
  },
  {
    title: 'Empresas',
    icon: 'BriefcaseIcon',
    children: [
      {
        title: 'Lista de Empresas',
        route: 'empresas-lista',
        icon: 'ListIcon',
      },
      {
        title: 'Nueva Empresa',
        route: 'empresas-nueva',
        icon: 'PlusIcon',
      },
    ],
  },
  {
    title: 'Contactos',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Lista de Contactos',
        route: 'contactos-lista',
        icon: 'ListIcon',
      },
      {
        title: 'Nuevo Contacto',
        route: 'contactos-nuevo',
        icon: 'PlusIcon',
      },
    ],
  },
  {
    title: 'Usuarios',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Lista de Usuarios',
        route: 'usuarios-lista',
        icon: 'ListIcon',
      },
      {
        title: 'Nuevo Usuario',
        route: 'usuarios-nuevo',
        icon: 'PlusIcon',
      },
      {
        title: 'Roles y Permisos',
        route: 'usuarios-roles',
        icon: 'ShieldIcon',
      },
    ],
  },
  // {
  //   title: 'Reportes',
  //   icon: 'BarChartIcon',
  //   children: [
  //     {
  //       title: 'Reportes de Proyectos',
  //       route: 'reportes-proyectos',
  //       icon: 'BarChartIcon',
  //     },
  //     {
  //       title: 'Reportes de Actividades',
  //       route: 'reportes-actividades',
  //       icon: 'BarChartIcon',
  //     },
  //     {
  //       title: 'Reportes de Obras',
  //       route: 'reportes-obras',
  //       icon: 'BarChartIcon',
  //     },
  //   ],
  // },
  {
    title: 'Catálogo',
    icon: 'BookOpenIcon',
    children: [
      {
        title: 'Estados de Actividades',
        route: 'catalogo-estados-actividades',
        icon: 'TagIcon',
      },
      {
        title: 'Acciones de Actividades',
        route: 'catalogo-acciones-actividades',
        icon: 'TagIcon',
      },
      {
        title: 'Tipos de Obras',
        route: 'catalogo-tipos-obras',
        icon: 'TagIcon',
      },
      {
        title: 'Referencias de Obras',
        route: 'catalogo-referencias-obras',
        icon: 'TagIcon',
      },
      {
        title: 'Fases',
        route: 'catalogo-fases',
        icon: 'TagIcon',
      },
      {
        title: 'Estados de Proyectos',
        route: 'catalogo-estados-proyectos',
        icon: 'TagIcon',
      },
      {
        title: 'Categorías de Archivos',
        route: 'catalogo-categorias-archivos',
        icon: 'TagIcon',
      },
      {
        title: 'Tipos de Empresas',
        route: 'catalogo-tipos-empresas',
        icon: 'TagIcon',
      },
    ],
  },
  {
    title: 'Configuración',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Mi Perfil',
        route: 'profile',
        icon: 'UserIcon',
      },
    ],
  },
]
